<ng-template #translatedContent let-translation="translation">
  <div class="translation">
    <div class="translatable-field">
      <mat-form-field>
        <mat-label>{{'packages.installedWidgets.titleOverwrite' | translate}}</mat-label>
        <input [(ngModel)]="translation.title" matInput>
      </mat-form-field>
      <mat-icon [matTooltip]="'dynamicContent.translateFromMain' | translate" *ngIf="translation.language !== 'de'" (click)="translateText(translation, translation.language, 'title')">translate</mat-icon>
      <div *ngIf="translation.language !== 'de'" class="disclaimer">{{'general.deeplDisclaimer' | translate}}</div>
    </div>
    <div class="translatable-field">
      <mat-form-field>
        <mat-label>{{'general.subtitle' | translate}}</mat-label>
        <input [(ngModel)]="translation.subtitle" matInput>
      </mat-form-field>
      <mat-icon [matTooltip]="'dynamicContent.translateFromMain' | translate" *ngIf="translation.language !== 'de'" (click)="translateText(translation, translation.language, 'subtitle')">translate</mat-icon>
      <div *ngIf="translation.language !== 'de'" class="disclaimer">{{'general.deeplDisclaimer' | translate}}</div>
    </div>
    <editor *ngIf="translation.widgetStyle === 'imageText' && translation.language === 'de'" height="150px"
            (changeContent)="widgetContentChange($event, translation)"></editor>
    <editor *ngIf="translation.widgetStyle === 'imageText' && translation.language !== 'de'" height="150px" [content]="translation.content"
            (changeContent)="widgetContentChange($event, translation)" [language]="translation.language" [mainLanguageContent]="getMainLanguageContent()"></editor>
    <div class="flex" *ngIf="translation.widgetStyle === 'iframe'">
      <div class="translatable-field">
        <mat-form-field>
          <mat-label>{{'packages.installedWidgets.widgetTypes.iframe' | translate}}</mat-label>
          <input [(ngModel)]="translation.iframe" matInput>
        </mat-form-field>
      </div>
      <div class="color">
        <input [(ngModel)]="translation.backgroundColor" type="color"/><span>Hintergrundfarbe</span>
        <span *ngIf="translation.backgroundColor" class="value">&nbsp;-&nbsp;{{translation.backgroundColor}}</span>
      </div>
    </div>
  </div>
</ng-template>

<h1>ibextouch Widgets > {{getTitle()}}</h1>

<h2>{{'packages.ibextouch.general' | translate}}</h2>

<div class="checkboxes">
  <ibex-checkbox [title]="'packages.installedWidgets.default' | translate" [checked]="item.default" (click)="item.default = $event.val"></ibex-checkbox>
  <ibex-checkbox [title]="'packages.installedWidgets.screenDisabled' | translate" [checked]="item.screenDisabled" (click)="item.screenDisabled = $event.val"></ibex-checkbox>
  <ibex-checkbox [title]="'packages.installedWidgets.fixed' | translate" [checked]="item.fixed" (click)="item.fixed = $event.val"></ibex-checkbox>
  <div class="clearable" *ngIf="(entrance && (!['ticker', 'important-news'].includes(entrance.type)) || !appItem.dynamicContentEntranceId)">
    <mat-form-field class="select">
      <mat-label>{{'packages.installedWidgets.widgetStyleSelect' | translate}}</mat-label>
      <mat-select #selectType (selectionChange)="changeType($event)" [value]="item?.translations?.[0]?.widgetStyle">
        <mat-option *ngFor="let type of ['imageText', 'image', 'galleryRandom', 'iframe', 'video']" [value]="type">{{'packages.installedWidgets.widgetTypes.' + type | translate}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button (click)="selectType.value = null; changeType()" mat-icon-button>
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>

<div class="ticker" *ngIf="entrance?.type === 'ticker'">
  <div class="color">
    <input [(ngModel)]="item.detail.backgroundColor" type="color"/><span>Standard Widget Hintergrundfarbe</span>
    <span *ngIf="item.detail.backgroundColor" class="value">&nbsp;-&nbsp;{{item.detail.backgroundColor}}</span>
  </div>

  <div class="color">
    <input [(ngModel)]="item.detail.color" type="color"/><span>Standard Widget Textfarbe</span>
    <span *ngIf="item.detail.color" class="value">&nbsp;-&nbsp;{{item.detail.color}}</span>
  </div>
</div>

<div class="images" *ngIf="showImageSelection()">
  <h2 style="margin: 20px 0 0">{{'general.images' | translate}}</h2>
  <div class="main-actions">
    <button (click)="addImage()" class="ibexfusion-raised-button" mat-button>{{ 'dynamicContent.chooseImage' | translate }}</button>
  </div>
  <div class="table-header">
    <div class="preview"></div>
    <div class="title">{{'general.title' | translate}}</div>
    <div class="publishing">{{ 'general.publishingImage' | translate }}</div>
    <div class="date">{{ 'general.created' | translate }}</div>
    <div class="size">{{'general.size' | translate}}</div>
    <div class="actions"></div>
  </div>

  <div class="table">
    <div *ngFor="let image of item.seasonalImages, let i = index" class="table-row">
      <div class="col preview">
        <smart-image [url]="imageAssetPath + image.imagePath + '/oneToOne'" class="image"></smart-image>
      </div>
      <div class="col title">{{ getAsset(image.imagePath)?.title }}</div>
      <div class="col publishing">
        <day-month-input (onChange)="updateDate('from', $event, i)" key="from" translationPrefix="packages.images" [value]="image.from"></day-month-input>
        <day-month-input (onChange)="updateDate('to', $event, i)" key="to" translationPrefix="packages.images" [value]="image.to"></day-month-input>
      </div>
      <div class="col date">
        <ng-container *ngIf="getAsset(image.imagePath)?.created">{{ getAsset(image.imagePath).created | date:'dd.MM.YYYY' }}</ng-container>
      </div>
      <div class="col size">
        <ng-container *ngIf="getAsset(image.imagePath)?.fileSize">{{ getAsset(image.imagePath).fileSize | fileSize }}</ng-container>
      </div>
      <div class="col actions">
        <button class="ibexfusion-icon-button" mat-icon-button (click)="editImage(i)"><mat-icon>edit</mat-icon></button>
        <button class="ibexfusion-icon-button" mat-icon-button (click)="removeImage(i)"><mat-icon>delete</mat-icon></button>
      </div>
    </div>
    <div class="empty" *ngIf="!item?.seasonalImages?.length">{{ 'dynamicContent.noMedia' | translate }}</div>
  </div>
</div>

<ng-container *ngIf="item.translations.length === 1">
  <ng-container *ngTemplateOutlet="translatedContent;context:{ translation: item.translations[0] }"></ng-container>
</ng-container>

<ng-container *ngIf="item.translations.length > 1">
  <h2 style="margin: 20px 0 0">{{'general.translations' | translate}}</h2>
  <mat-tab-group>
    <mat-tab *ngFor="let translation of item.translations" [label]="'general.languages.' + translation.language | translate">
      <ng-container *ngTemplateOutlet="translatedContent;context:{ translation }"></ng-container>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<code-area *ngIf="superadmin" [options]="codeEditorOptions" [parent]="item" [value]="item.detail" key="detail" type="json"></code-area>
